module.exports = __webpack_public_path__ + "img/flower_center.67ecb57.webp";